import { Apollo } from 'src/gql/generated';

export function useCurrentUserId(): UUID | null {
  const user = useSelectCurrentUser();
  return user?.id ?? null;
}

export function useSelectCurrentUser() {
  const { currentUser } = useCurrentUserQuery();
  return currentUser;
}

export function useIsViewer() {
  const currentUser = useSelectCurrentUser();
  return currentUser?.role === Apollo.OrgRole.Viewer;
}

export function useIsOrgAdmin() {
  const { currentUser, loading } = useCurrentUserQuery();
  return {
    currentUser,
    isOrgAdmin: currentUser?.role === Apollo.OrgRole.Admin,
    loading,
  };
}

export type CurrentUserType = ReturnType<typeof useCurrentUserQuery>['currentUser'];

export function useCurrentUserQuery(options?: Parameters<typeof Apollo.useCurrentUserQuery>[0]) {
  const { data, loading } = Apollo.useCurrentUserQuery(options);
  return {
    currentUser: data?.currentUser ?? null,
    loading,
  };
}

export function useCurrentUserSubscription() {
  const { data, loading } = Apollo.useGetUserAccessLevelQuery();
  return { currentUser: data?.currentUser ?? null, loading };
}
